import { render, staticRenderFns } from "./detail-inner-item.vue?vue&type=template&id=597774c5&scoped=true"
import script from "./detail-inner-item.vue?vue&type=script&setup=true&lang=js"
export * from "./detail-inner-item.vue?vue&type=script&setup=true&lang=js"
import style0 from "./detail-inner-item.vue?vue&type=style&index=0&id=597774c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597774c5",
  null
  
)

export default component.exports